import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography, TextField, Grid, MenuItem, Select, FormControl, InputLabel, Divider } from "@mui/material";
import { Add, CheckCircle, Download } from '@mui/icons-material';
import apiService from "../../service/apiService";
import { FaListAlt, FaArrowRight, FaMap, FaCrop, FaUsers, FaEye, FaRegEdit, FaTrash, FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ReactApexChart from "react-apexcharts";
import '../../assets/styles/cropmanage.css';
import * as XLSX from "xlsx";
import UploadIcon from '@mui/icons-material/Upload';
import { Pagination } from "react-bootstrap";
import { format, parseISO } from "date-fns";
import { debounce } from "lodash";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Croproduction = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Essential state variables only
  const [openEdit, setOpenEdit] = useState(false);
  const [pageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [newState, setNewState] = useState({ seasonId: null, yearId: null, farmerId: null });
  const [seasons, setSeasons] = useState([]);
  const [years, setYears] = useState([]);
  const [farmers, setFarmers] = useState([]);
  const [farmerName, setFarmerName] = useState('');
  const [seeds, setSeeds] = useState([]);
  const [totalItems, setTotalitems] = useState(0);
  const [totalpage, setTotalpage] = useState(0);
  const [farName, setFarName] = useState("");
  const [gendid, setGendId] = useState(0);
  const [genders, setGenders] = useState([]);
  const [castid, setCastId] = useState(0);
  const [sesid, setSesId] = useState(location.state?.season || 0);
  const [pgcode, setPgCode] = useState("");
  const [cultvarea, setCultarea] = useState(null);
  const [prodqty, setProdQty] = useState(null);
  const [castes, setCastes] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [cropPlans, setCropPlans] = useState([]);
  const [seedVarietyId, setSeedVarietyId] = useState('');
  const [seedVarieties, setSeedVarieties] = useState([]);
  const [seedClassId, setSeedClassId] = useState('');
  const [seedClasses, setSeedClasses] = useState([]);
  const [cropTypes, setCropTypes] = useState([]);
  const [cropPlanMasterId, setCropPlanMasterId] = useState("");
  const [seedId, setSeedId] = useState("");
  const [cropTypeId, setCropTypeId] = useState("");
  const [area, setArea] = useState("");
  const [leasearea, setLeaseArea] = useState("");
  const [quantity, setQuantity] = useState("");
  const [openAddPlan, setOpenAddPlan] = useState(false);
  const [selectedSeasonId, setSelectedSeasonId] = useState(0);
  const [carddata, setCardData] = useState([]);
  const [alldata, setAllData] = useState([]);
  const [year, setYear] = useState(location.state?.year || null);
  const [showBreakupfarmer, setShowBreakupfarmer] = useState(false);
  const [showBreakupplan, setShowBreakupplan] = useState(false);
  const [crops, setCrops] = useState([]);
  const [farmersData, setFarmersData] = useState([]);
  const [farmerArea, setfarmerArea] = useState([]);
  const [planmstrid, setPlanmstrId] = useState(null);
  const [isLeaseArea, setIsLeaseArea] = useState(false);
  const [selectedFarmerid, setSelectedFarmerId] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [districts, setDistricts] = useState([]);
  const [availablearea, setAvailableArea] = useState(0);
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);

  // Add these state variables near the top with other useState declarations
  const [openEditDialog, setOpenEditDialog] = useState(false);

  // Add these missing handler functions
  const handleDateChange = (date) => {
    const formattedDate = format(date, 'dd-MM-yyyy');
    setNewState({ ...newState, registeredDate: formattedDate });
  };

  const handleCloseAdd = () => {
    setOpenAdd(false);
    setNewState({
      farmerName: '',
      Caste: '',
      pgCode: '',
      season: '',
      cultivatedArea: '',
      productionQuantity: '',
      registeredDate: ''
    });
  };

  const handleSaveAdd = async (newState) => {
    try {
      const response = await apiService.post("/crop-master/create", {
        farmerName: newState.farmerName,
        caste: newState.Caste,
        pgCode: newState.pgCode,
        season: newState.season,
        cultivatedArea: newState.cultivatedArea,
        productionQuantity: newState.productionQuantity
      });

      console.log("Create response:", response.data);
      fetchData();
    } catch (error) {
      console.error("Error creating production:", error);
    } finally {
      handleCloseAdd();
    }
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setSelectedRow(null);
  };

  const handleCloseEdit = () => {
    setOpenEdit(false);
    setSelectedRow(null);
  };

  const handleSaveEdit = async () => {
    try {
      const {
        cropProductionMasterId,
        farmerName,
        cultivatedArea,
        productionQuantity,
      } = selectedRow;

      const payload = {
        farmerName,
        cultivatedArea: parseFloat(cultivatedArea),
        productionQuantity: parseFloat(productionQuantity),
      };

      const response = await apiService.put(
        `/crop-master/update/${cropProductionMasterId}`,
        payload
      );

      console.log("Update response:", response.data);
      fetchData();
    } catch (error) {
      console.error("Error updating crop production:", error);
    } finally {
      setOpenEdit(false);
    }
  };

  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const [dist, setDist] = useState(
    loginData?.districtId !== null && loginData?.districtId !== undefined
      ? loginData.districtId
      : (location.state?.dist && location.state.dist !== 0 ? location.state.dist : 0)
  );
  const [blk, setBlk] = useState(
    loginData?.blockId !== null && loginData?.blockId !== undefined
      ? loginData.blockId
      : (location.state?.blk && location.state.blk !== 0 ? location.state.blk : 0)
  );

  const handleSelectRow = (id, isVerified) => {
    if (isVerified) return;
    setSelectedRows((prev) => {
      const newSelectedRows = prev.includes(id)
        ? prev.filter((rowId) => rowId !== id)
        : [...prev, id];
      setSelectAll(newSelectedRows.length === alldata.filter((data) => !data.isVerified).length);
      return newSelectedRows;
    });
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
    } else {
      const selectableIds = alldata.filter((data) => !data.isVerified).map((data) => data.cropProductionMasterId);
      setSelectedRows(selectableIds);
    }
    setSelectAll(!selectAll);
  };

  useEffect(() => {
    const loadDistricts = async () => {
      try {
        const res = await apiService.get("/districts/get-all");
        if (res.data) {
          setDistricts(res.data);
        }
      } catch (err) {
        console.error("Error fetching districts:", err);
      }
    };
    loadDistricts();
  }, []);

  const toggleBreakupFarmer = () => {
    setShowBreakupfarmer(!showBreakupfarmer);
  };

  const fetchData = async () => {
    try {
      const response = await apiService.post("/crop-master/get-all-production-index-data", {
        farmerId: 0,
        producerGroupId: 0,
        seasonId: selectedSeasonId,
        farmerName: farName,
        genderId: gendid,
        casteId: castid,
        pgCode: pgcode,
        yield5x5: null,
        cultivatedArea: cultvarea,
        productionQuantity: prodqty,
        pageNumber: page,
        pageSize: pageSize,
        yearValue: year,
        districtId: dist,
        blockId: blk
      });

      if (response.data.status && response.data.body && response.data.body.data) {
        const data = response.data.body.data;
        const formattedData = data.map((item) => ({
          cropProductionMasterId: item.cropProductionMasterId,
          farmerId: item.farmerId,
          farmerName: item.farmerName,
          gender: item.gender,
          caste: item.caste,
          seasonName: item.seasonName,
          pgCode: item.pgCode,
          cultivatedArea: item.cultivatedArea || 0,
          productionQuantity: item.productionQuantity || 0,
          isVerified: item.isVerified
        }));

        setAllData(formattedData);
        setTotalitems(response.data.body.recordsCount);
        setTotalpage(response.data.body.pageCount);
        setRows(formattedData);
      } else {
        setTotalitems(0);
        setTotalpage(0);
        setAllData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setAllData([]);
      setTotalitems(0);
      setTotalpage(0);
    }
  };

  const debouncedFetchData = useCallback(debounce(fetchData, 500), [
    farName, gendid, castid, sesid, selectedSeasonId, pgcode, cultvarea, prodqty,
    page, pageSize, year, blk, dist
  ]);

  useEffect(() => {
    debouncedFetchData();
    return () => debouncedFetchData.cancel();
  }, [debouncedFetchData]);

  const fetchCardData = async () => {
    try {
      const response = await apiService.post(`/dashboard/crop-production`, {
        seasonId: selectedSeasonId,
        year: year,
        districtId: dist,
        blockId: blk
      });
      setCardData(response.data.body);
    } catch (error) {
      console.error("Error fetching card data:", error);
    }
  };

  const fetchgraphData = async () => {
    try {
      const response = await apiService.post(`/dashboard/crop-production-graph`, {
        seasonId: selectedSeasonId,
        year: year,
        districtId: dist,
        blockId: blk
      });

      const body = response.data?.body;
      if (!response.data?.status || !response.data?.body) {
        setCrops([]);
        setFarmersData([]);
        setfarmerArea([]);
        return;
      }

      const crops = Object.keys(body).filter(key => key !== 'Season');
      setCrops(crops);
      const farmersData = crops.map(crop => body[crop]?.farmersCount || 0);
      setFarmersData(farmersData);
      const areaData = crops.map(crop => body[crop]?.totalCultivatedArea || 0);
      setfarmerArea(areaData);
    } catch (error) {
      console.error("Error fetching graph data:", error);
    }
  };

  const fetchSeasons = async () => {
    try {
      const response = await apiService.get("/seasons/get-all");
      setSeasons(response.data);
    } catch (error) {
      console.error("Error fetching seasons:", error);
    }
  };

  const fetchYears = async () => {
    try {
      const response = await apiService.get("/years/get-all");
      setYears(response.data);
      const currentYear = new Date().getFullYear();
      const defaultYear = response.data.find((yr) => yr.yearValue === currentYear);
      setYear(defaultYear ? defaultYear.yearValue : response.data[0].yearValue);
    } catch (error) {
      console.error("Error fetching years:", error);
    }
  };

  const fetchCaste = async () => {
    try {
      const response = await apiService.get("/castes/get-all");
      setCastes(response.data);
    } catch (error) {
      console.error("Error fetching castes:", error);
    }
  };

  useEffect(() => {
    fetchSeasons();
    fetchYears();
    fetchCaste();
  }, []);

  useEffect(() => {
    if (selectedSeasonId !== null && year !== null) {
      fetchCardData();
      fetchgraphData();
    }
  }, [selectedSeasonId, year, dist, blk]);

  // Chart configuration
  const getColumnWidth = () => {
    const numCrops = crops.length;
    if (numCrops <= 1) return "5%";
    else if (numCrops <= 4) return "10%";
    else return "30%";
  };

  const chartOptions = {
    chart: { type: "bar", toolbar: { show: true } },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: getColumnWidth(),
        borderRadius: 5,
        borderRadiusApplication: "end",
      },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: crops,
      title: { text: "Crops", style: { fontSize: "14px", fontWeight: "bold" } },
    },
    yaxis: {
      title: { text: "Counts", style: { fontSize: "14px", fontWeight: "bold" } },
    },
    colors: ["#00773E", "#ee781c"],
    legend: { position: "bottom", horizontalAlign: "center" },
    grid: { borderColor: "#e7e7e7", strokeDashArray: 5 },
  };

  const chartSeries = [
    { name: "Farmer (no.)", data: farmersData },
    { name: "Total Area (ha)", data: farmerArea },
  ];

  // Event handlers
  const handleView = async (data) => {
    navigate("/childproduction", { state: { data: data } });
  };

  const handleDelete = (id) => {
    setSelectedRow(alldata.find((row) => row.cropProductionMasterId === id));
    setOpenDelete(true);
  };

  const handleDeleteRow = async () => {
    try {
      const { cropProductionMasterId } = selectedRow;
      await apiService.delete(`/crop-master/${cropProductionMasterId}`);
      fetchData();
    } catch (error) {
      console.error("Error deleting data:", error);
    } finally {
      setOpenDelete(false);
    }
  };

  const handleVerify = async () => {
    const isConfirmed = window.confirm("Are you sure you want to verify the selected crop production?");
    if (!isConfirmed) return;

    try {
      const response = await apiService.put('/crop-master/verify', {
        cropProductionMasterIds: selectedRows,
        remarks: "Verified successfully"
      });

      if (response.status === 200) {
        alert("Verification successful!");
        setSelectedRows([]);
        fetchData();
      }
    } catch (error) {
      alert("Error verifying records: " + error.message);
    }
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const renderPaginationItems = () => {
    const paginationItems = [];
    const maxPagesToShow = 7;
    const startPages = 3;
    const endPages = 2;

    if (totalpage <= maxPagesToShow) {
      for (let pages = 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    } else {
      for (let pages = 1; pages <= startPages; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      if (page > startPages + 1) {
        paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" />);
      }

      const middlePages = [];
      const startMiddlePage = Math.max(page - 1, startPages + 1);
      const endMiddlePage = Math.min(page + 1, totalpage - endPages);

      for (let pages = startMiddlePage; pages <= endMiddlePage; pages++) {
        middlePages.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      paginationItems.push(...middlePages);

      if (page < totalpage - endPages - 1) {
        paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" />);
      }

      for (let pages = totalpage - endPages + 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    }

    return paginationItems;
  };

  const exportToExcel = async () => {
    const headers = [
      ["Farmer Name", "Gender", "Caste", "Season", "PG Code", "Cultivated Area (ha)", "Production Quantity (q)", "Status"]
    ];

    const payload = {
      "farmerId": 0, "producerGroupId": 0, "seasonId": 0, "farmerName": "",
      "genderId": 0, "casteId": 0, "pgCode": "", "yield5x5": null,
      "cultivatedArea": null, "productionQuantity": null,
      "year": year, "pageNumber": page, "pageSize": 1000000000
    };

    try {
      const response = await apiService.post("/crop-master/get-all-production-index-data", payload);

      if (response && response.data && response.data.body && response.data.body.data) {
        const cropProductionData = response.data.body.data;
        const dataRows = cropProductionData.map(data => [
          data.farmerName, data.gender, data.caste, data.seasonName, data.pgCode,
          data.cultivatedArea, data.productionQuantity,
          data.isVerified ? "Verified" : "Not Verified"
        ]);

        const worksheetData = [...headers, ...dataRows];
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Crop Production");
        XLSX.writeFile(workbook, `Crop_Production_Data_${year}.xlsx`);
      }
    } catch (error) {
      console.error("Error fetching data or exporting to Excel:", error);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  return (
    <Box m="2px">
      <div style={{ maxHeight: "100vh", overflowY: "auto" }}>
        {/* Header - Same design as cropmanage */}
        <div style={{
          backgroundColor: "#ffffff",
          borderBottom: "3px solid #007bff",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
        }}>
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center py-3 px-4">
              <div className="d-flex align-items-center">
                <div>
                  <h1 style={{
                    fontSize: "1.8rem",
                    fontWeight: "600",
                    color: "#2c3e50",
                    margin: "0"
                  }}>
                    Crop Production Dashboard
                  </h1>
                </div>
              </div>

              <div className="d-flex align-items-center gap-3">
                <div className="d-flex align-items-center">
                  <label style={{
                    fontWeight: "500",
                    color: "#495057",
                    marginRight: "10px",
                    fontSize: "14px"
                  }}>
                    Year:
                  </label>
                  <select
                    className="form-select"
                    value={year || 0}
                    onChange={(e) => setYear(Number(e.target.value))}
                    style={{
                      border: "1px solid #ced4da",
                      borderRadius: "6px",
                      padding: "6px 12px",
                      fontSize: "14px",
                      minWidth: "100px",
                      backgroundColor: "#fff"
                    }}
                  >
                    <option value={0} disabled>Select Year</option>
                    {years.map((yr) => (
                      <option key={yr.yearId} value={yr.yearValue}>
                        {yr.yearValue}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="d-flex align-items-center">
                  <label style={{
                    fontWeight: "500",
                    color: "#495057",
                    marginRight: "10px",
                    fontSize: "14px"
                  }}>
                    District:
                  </label>
                  <select
                    className="form-select"
                    value={dist || 0}
                    onChange={(e) => { setDist(Number(e.target.value)); setPage(1); }}
                    style={{
                      border: "1px solid #ced4da",
                      borderRadius: "6px",
                      padding: "6px 12px",
                      fontSize: "14px",
                      minWidth: "150px",
                      backgroundColor: "#fff"
                    }}
                  >
                    <option value={0}>Select All</option>
                    {districts.map((d) => (
                      <option key={d.districtId} value={d.districtId}>
                        {d.districtName}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="d-flex align-items-center">
                  <label style={{
                    fontWeight: "500",
                    color: "#495057",
                    marginRight: "10px",
                    fontSize: "14px"
                  }}>
                    Season:
                  </label>
                  <select
                    className="form-select"
                    value={selectedSeasonId}
                    onChange={(e) => { setSelectedSeasonId(Number(e.target.value)); setPage(1); }}
                    style={{
                      border: "1px solid #ced4da",
                      borderRadius: "6px",
                      padding: "6px 12px",
                      fontSize: "14px",
                      minWidth: "120px",
                      backgroundColor: "#fff"
                    }}
                  >
                    <option value={0}>Select All</option>
                    {seasons.map((ses) => (
                      <option key={ses.seasonId} value={ses.seasonId}>
                        {ses.seasonName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Dashboard Cards - Updated to match index.jsx design */}
        <div className="row g-3 mx-3 mt-1">
          <div className="col-3">
            <div
              className="d-flex align-items-center justify-content-between p-4 position-relative"
              style={{
                minHeight: "120px",
                backgroundColor: "#d4edc9",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "0.2s ease-in-out",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#c7e6b8")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#d4edc9")}
              onClick={toggleBreakupFarmer}
            >
              <FaUsers size={60} style={{ color: "#2e7d32" }} />
              <div className="text-end flex-grow-1">
                <h5 className="fw-bold mb-0" style={{ color: "#2e7d32" }}>
                  {carddata?.totalFarmerCount || 0}
                </h5>
                <small className="fw-bold" style={{ color: "#33691e", fontSize: "15px" }}>
                  Participant Farmers (no.)
                </small>
                <div className="mt-2 fw-bold" style={{ fontSize: "12px", color: "#2e7d32" }}>
                  {showBreakupfarmer ? "Close Breakup" : "View Breakup"} <FaArrowRight />
                </div>
              </div>
              {showBreakupfarmer && (
                <div className="position-absolute p-3 text-dark rounded shadow"
                  style={{
                    backgroundColor: "white", top: "50%", left: "50%",
                    transform: "translate(-50%, -50%)", width: "90%", zIndex: 10,
                    borderRadius: "12px"
                  }}>
                  <div className="text-start">
                    <p className="mb-1 fw-bold">Men: <span className="text-primary">{carddata?.maleCount || 0}</span></p>
                    <p className="mb-0 fw-bold">Women: <span className="text-danger">{carddata?.femaleCount || 0}</span></p>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="col-3">
            <div
              className="d-flex align-items-center justify-content-between p-4"
              style={{
                minHeight: "120px",
                backgroundColor: "#d4edc9",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "0.2s ease-in-out",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#c7e6b8")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#d4edc9")}
            >
              <FaListAlt size={60} style={{ color: "#2e7d32" }} />
              <div className="text-end flex-grow-1">
                <h5 className="fw-bold mb-0" style={{ color: "#2e7d32" }}>
                  {carddata?.totalPgCount || 0}
                </h5>
                <small className="fw-bold" style={{ color: "#33691e", fontSize: "15px" }}>
                  Participant PGs (no.)
                </small>
              </div>
            </div>
          </div>

          <div className="col-3">
            <div
              className="d-flex align-items-center justify-content-between p-4"
              style={{
                minHeight: "120px",
                backgroundColor: "#d4edc9",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "0.2s ease-in-out",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#c7e6b8")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#d4edc9")}
            >
              <FaMap size={60} style={{ color: "#2e7d32" }} />
              <div className="text-end flex-grow-1">
                <h5 className="fw-bold mb-0" style={{ color: "#2e7d32" }}>
                  {carddata?.totalCultivatedArea || 0}
                </h5>
                <small className="fw-bold" style={{ color: "#33691e", fontSize: "15px" }}>
                  Production Area (ha)
                </small>
              </div>
            </div>
          </div>

          <div className="col-3">
            <div
              className="d-flex align-items-center justify-content-between p-4"
              style={{
                minHeight: "120px",
                backgroundColor: "#d4edc9",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "0.2s ease-in-out",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#c7e6b8")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#d4edc9")}
            >
              <FaCrop size={60} style={{ color: "#2e7d32" }} />
              <div className="text-end flex-grow-1">
                <h5 className="fw-bold mb-0" style={{ color: "#2e7d32" }}>
                  {carddata?.totalCropProductions || 0}
                </h5>
                <small className="fw-bold" style={{ color: "#33691e", fontSize: "15px" }}>
                  Total Crop Production (q)
                </small>
              </div>
            </div>
          </div>
        </div>

        {/* Chart Section */}
        {/* <div className="d-flex justify-content-between align-items-center mt-4 mx-3">
          <div className="fw-bold fs-5">Season Analysis Summary</div>
        </div>
        <div className="mt-4 mb-2 mx-3">
          <ReactApexChart options={chartOptions} series={chartSeries} type="bar" height={350} />
        </div> */}

        {/* Action Buttons */}
        <div className="d-flex justify-content-between align-items-center mt-3 mx-3">
          <div className="fw-bold fs-5">Farmer-wise Crop Production Details</div>
          <div className="d-flex align-items-center gap-3">
            <Button
              variant="contained"
              onClick={exportToExcel}
              style={{
                backgroundColor: "#007bff",
                border: "none",
                borderRadius: "6px",
                padding: "8px 16px",
                fontSize: "14px",
                fontWeight: "500",
                textTransform: "none"
              }}
            >
              Export Excel
            </Button>

            {/* <Button
              variant="contained"
              onClick={handleVerify}
              disabled={selectedRows.length === 0}
              style={{
                backgroundColor: "#00796b",
                border: "none",
                borderRadius: "6px",
                padding: "8px 16px",
                fontSize: "14px",
                fontWeight: "500",
                textTransform: "none",
                opacity: selectedRows.length === 0 ? 0.6 : 1
              }}
            >
              Verify
            </Button> */}
          </div>
        </div>

        {/* Table Section - Same design as cropmanage */}
        <div className="mx-2" style={{ minHeight: "75vh", overflowY: "auto", overflowX: "auto", maxWidth: "100%", whiteSpace: "nowrap" }}>
          <table className="table table-hover mb-0" style={{
            minWidth: "1200px",
            backgroundColor: "#fff"
          }}>
            <thead style={{
              backgroundColor: "#007bff",
              color: "white",
              position: "sticky",
              top: "0",
              zIndex: "10"
            }}>
              <tr>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  textAlign: "center",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "60px"
                }}>
                  <input
                    type="checkbox"
                    onChange={handleSelectAll}
                    checked={selectAll && selectedRows.length > 0}
                    style={{ transform: "scale(1.2)" }}
                  />
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "150px"
                }}>
                  Farmer Name
                  <br />
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm mt-2"
                    value={farName}
                    onChange={(e) => { setFarName(e.target.value); setPage(1); }}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      fontSize: "12px",
                      color: "#333",
                      padding: "4px 8px"
                    }}
                  />
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "100px"
                }}>
                  Gender
                  <br />
                  <select
                    value={gendid}
                    onChange={(e) => { setGendId(e.target.value); setPage(1); }}
                    className="form-control form-control-sm mt-2"
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      fontSize: "12px",
                      color: "#333",
                      padding: "4px 8px"
                    }}
                  >
                    <option value={0}>All</option>
                    <option value={1}>Male</option>
                    <option value={2}>Female</option>
                    <option value={3}>Other</option>
                  </select>
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "100px"
                }}>
                  Caste
                  <br />
                  <select
                    value={castid}
                    onChange={(e) => { setCastId(e.target.value); setPage(1); }}
                    className="form-control form-control-sm mt-2"
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      fontSize: "12px",
                      color: "#333",
                      padding: "4px 8px"
                    }}
                  >
                    <option value={0}>All</option>
                    {castes.map((caste) => (
                      <option key={caste.casteId} value={caste.casteId}>
                        {caste.caste}
                      </option>
                    ))}
                  </select>
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "100px"
                }}>
                  Season
                  <br />
                  <select
                    value={selectedSeasonId}
                    onChange={(e) => { setSelectedSeasonId(Number(e.target.value)); setPage(1); }}
                    className="form-control form-control-sm mt-2"
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      fontSize: "12px",
                      color: "#333",
                      padding: "4px 8px"
                    }}
                  >
                    <option value={0}>All</option>
                    {seasons.map((season) => (
                      <option key={season.seasonId} value={season.seasonId}>
                        {season.seasonName}
                      </option>
                    ))}
                  </select>
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "120px"
                }}>
                  PG Code
                  <br />
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm mt-2"
                    value={pgcode}
                    onChange={(e) => { setPgCode(e.target.value); setPage(1); }}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      fontSize: "12px",
                      color: "#333",
                      padding: "4px 8px"
                    }}
                  />
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "120px"
                }}>
                  Cultivated Area (ha)
                  <br />
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm mt-2"
                    value={cultvarea}
                    onChange={(e) => { setCultarea(e.target.value); setPage(1); }}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      fontSize: "12px",
                      color: "#333",
                      padding: "4px 8px"
                    }}
                  />
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "120px"
                }}>
                  Production (q)
                  <br />
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm mt-2"
                    value={prodqty}
                    onChange={(e) => {
                      const value = e.target.value;
                      setProdQty(value ? value : null);
                      setPage(1);
                    }}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      fontSize: "12px",
                      color: "#333",
                      padding: "4px 8px"
                    }}
                  />
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "100px",
                  textAlign: "center"
                }}>
                  Status
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  textAlign: "center",
                  minWidth: "150px"
                }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody style={{ fontSize: "13px" }}>
              {alldata.map((data, index) => (
                <tr key={index} style={{
                  backgroundColor: index % 2 === 0 ? "#f8f9fa" : "#ffffff",
                  borderBottom: "1px solid #dee2e6"
                }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#e3f2fd";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = index % 2 === 0 ? "#f8f9fa" : "#ffffff";
                  }}>
                  <td style={{
                    padding: "12px 8px",
                    textAlign: "center",
                    borderRight: "1px solid #dee2e6"
                  }}>
                    <input
                      type="checkbox"
                      checked={selectedRows.includes(data.cropProductionMasterId)}
                      onChange={() => handleSelectRow(data.cropProductionMasterId, data.isVerified)}
                      disabled={data.isVerified}
                      style={{ transform: "scale(1.2)" }}
                    />
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    color: "#495057",
                    borderRight: "1px solid #dee2e6",
                    fontWeight: "500"
                  }}>
                    {data.farmerName}
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    color: "#495057",
                    borderRight: "1px solid #dee2e6"
                  }}>
                    <span style={{
                      backgroundColor: data.gender === 'Male' ? '#d4edda' : data.gender === 'Female' ? '#f8d7da' : '#fff3cd',
                      color: data.gender === 'Male' ? '#155724' : data.gender === 'Female' ? '#721c24' : '#856404',
                      padding: "3px 8px",
                      borderRadius: "4px",
                      fontSize: "11px",
                      fontWeight: "500"
                    }}>
                      {data.gender}
                    </span>
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    color: "#495057",
                    borderRight: "1px solid #dee2e6"
                  }}>
                    {data.caste}
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    color: "#495057",
                    borderRight: "1px solid #dee2e6"
                  }}>
                    <span style={{
                      backgroundColor: data.seasonName === 'Rabi' ? '#d4edda' : '#fff3cd',
                      color: data.seasonName === 'Rabi' ? '#155724' : '#856404',
                      padding: "3px 8px",
                      borderRadius: "4px",
                      fontSize: "11px",
                      fontWeight: "500"
                    }}>
                      {data.seasonName}
                    </span>
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    color: "#495057",
                    borderRight: "1px solid #dee2e6"
                  }}>
                    {data.pgCode}
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    textAlign: "center",
                    fontWeight: "600",
                    color: "#495057",
                    borderRight: "1px solid #dee2e6"
                  }}>
                    <span style={{
                      backgroundColor: '#007bff',
                      color: 'white',
                      padding: "3px 8px",
                      borderRadius: "4px",
                      fontSize: "12px",
                      fontWeight: "600"
                    }}>
                      {data.cultivatedArea}
                    </span>
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    textAlign: "center",
                    fontWeight: "600",
                    color: "#495057",
                    borderRight: "1px solid #dee2e6"
                  }}>
                    <span style={{
                      backgroundColor: '#28a745',
                      color: 'white',
                      padding: "3px 8px",
                      borderRadius: "4px",
                      fontSize: "12px",
                      fontWeight: "600"
                    }}>
                      {data.productionQuantity}
                    </span>
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    textAlign: "center",
                    fontWeight: "600",
                    borderRight: "1px solid #dee2e6"
                  }}>
                    <span style={{
                      color: data.isVerified ? "#28a745" : "#dc3545",
                      fontWeight: "600",
                      fontSize: "12px"
                    }}>
                      {data.isVerified ? "Verified" : "Not Verified"}
                    </span>
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    textAlign: "center"
                  }}>
                    <div style={{ display: "flex", gap: "5px", justifyContent: "center" }}>
                      <button
                        className="btn btn-sm btn-info"
                        onClick={() => handleView(data)}
                        title="View"
                        style={{
                          padding: "4px 8px",
                          fontSize: "12px"
                        }}
                      >
                        <FaEye />
                      </button>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(data.cropProductionMasterId)}
                        title="Delete"
                        style={{
                          padding: "4px 8px",
                          fontSize: "12px"
                        }}
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className='d-flex justify-content-between pb-0'>
          <div className='p-2'>
            Showing {(page - 1) * 10 + 1} to {Math.min(page * 10, totalItems)} of {totalItems} items
          </div>
          <div className='p-2'>
            <Pagination className="mb-0">
              <Pagination.First onClick={() => handlePageChange(1)} disabled={page === 1} />
              <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 1} />
              {renderPaginationItems()}
              <Pagination.Next onClick={() => handlePageChange(page + 1)} disabled={page === totalpage} />
              <Pagination.Last onClick={() => handlePageChange(totalpage)} disabled={page === totalpage} />
            </Pagination>
          </div>
        </div>

        {/* Dialog for Show Farmer */}

        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
          <DialogTitle>farmer Management</DialogTitle>
          <DialogContent>
            {selectedRow && (
              <>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary">
                    <strong>farmer farmerName:</strong>
                  </Typography>
                  <Typography variant="body1">{selectedRow.farmerName}</Typography>
                </Box>

                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary">
                    <strong>Caste:</strong>
                  </Typography>
                  <Typography variant="body1">{selectedRow.Caste}</Typography>
                </Box>

                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary">
                    <strong>pg Code:</strong>
                  </Typography>
                  <Typography variant="body1">{selectedRow.pgCode}</Typography>
                </Box>

                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary">
                    <strong>Season:</strong>
                  </Typography>
                  <Typography variant="body1">{selectedRow.season}</Typography>
                </Box>

                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary">
                    <strong>plannedArea:</strong>
                  </Typography>
                  <Typography variant="body1">{selectedRow.plannedArea}</Typography>
                </Box>

                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary">
                    <strong>Coverage Area:</strong>
                  </Typography>
                  <Typography variant="body1">{selectedRow.coverageArea}</Typography>
                </Box>

                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary">
                    <strong>Seed Class:</strong>
                  </Typography>
                  <Typography variant="body1">{selectedRow.SeedClass}</Typography>
                </Box>

                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary">
                    <strong>Seed Name:</strong>
                  </Typography>
                  <Typography variant="body1">{selectedRow.SeedName}</Typography>
                </Box>

                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary">
                    <strong>Variety:</strong>
                  </Typography>
                  <Typography variant="body1">{selectedRow.variety}</Typography>
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary">
                    <strong>Toatl (Kg):</strong>
                  </Typography>
                  <Typography variant="body1">{selectedRow.toatlKg}</Typography>
                </Box>

                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary">
                    <strong>CreatePGFname:</strong>
                  </Typography>
                  <Typography variant="body1">{selectedRow.CreatePGFname}</Typography>
                </Box>

                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" color="textSecondary">
                    <strong>CreatedBy:</strong>
                  </Typography>
                  <Typography variant="body1">{selectedRow.createdBy}</Typography>
                </Box>



              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary" variant="contained">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Add the Dialog for Add Production */}

        <Dialog open={openAdd} onClose={handleCloseAdd}>
          <DialogTitle>Add Production</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Farmer Name"
              fullWidth
              variant="outlined"
              value={newState.farmerName}
              onChange={(e) => setNewState({ ...newState, farmerName: e.target.value })}
            />

            <FormControl fullWidth margin="dense" variant="outlined">
              <InputLabel id="caste-label">Caste</InputLabel>
              <Select
                labelId="caste-label"
                value={newState.Caste}
                onChange={(e) => setNewState({ ...newState, Caste: e.target.value })}
                label="Caste"
              >
                {castes.map((caste) => (
                  <MenuItem key={caste.casteId} value={caste.casteId}>
                    {caste.casteName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>


            <TextField
              margin="dense"
              label="Pg Code"
              fullWidth
              variant="outlined"
              value={newState.pgCode}
              onChange={(e) => setNewState({ ...newState, pgCode: e.target.value })}
            />

            <FormControl fullWidth margin="dense" variant="outlined">
              <InputLabel id="season-label">Season</InputLabel>
              <Select
                labelId="season-label"
                value={newState.season}
                onChange={(e) => setNewState({ ...newState, season: e.target.value })}
                label="Season"
              >
                {seasons.map((season) => (
                  <MenuItem key={season.seasonId} value={season.seasonId}>
                    {season.seasonName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              margin="dense"
              label="Planned Area"
              fullWidth
              variant="outlined"
              value={newState.plannedArea}
              onChange={(e) => setNewState({ ...newState, plannedArea: e.target.value })}
            />
            <TextField
              margin="dense"
              label="Coverage Area"
              fullWidth
              variant="outlined"
              value={newState.coverageArea}
              onChange={(e) => setNewState({ ...newState, coverageArea: e.target.value })}
            />
            <TextField
              margin="dense"
              label="Seed Class"
              fullWidth
              variant="outlined"
              value={newState.SeedClass}
              onChange={(e) => setNewState({ ...newState, SeedClass: e.target.value })}
            />

            <FormControl fullWidth margin="dense" variant="outlined">
              <InputLabel id="seed-label">Seed Name</InputLabel>
              <Select
                labelId="seed-label"
                value={newState.SeedName}
                onChange={(e) => setNewState({ ...newState, SeedName: e.target.value })}
                label="Seed Name"
              >
                {seeds.map((seed) => (
                  <MenuItem key={seed.seedId} value={seed.seedId}>
                    {seed.seedName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              margin="dense"
              label="Variety"
              fullWidth
              variant="outlined"
              value={newState.variety}
              onChange={(e) => setNewState({ ...newState, variety: e.target.value })}
            />
            <TextField
              margin="dense"
              label="Toatl (Kg)"
              fullWidth
              variant="outlined"
              value={newState.toatlKg}
              onChange={(e) => setNewState({ ...newState, toatlKg: e.target.value })}
            />
            <TextField

              margin="dense"
              label="CreatePGFname"
              fullWidth
              variant="outlined"
              value={newState.CreatePGFname}
              onChange={(e) => setNewState({ ...newState, CreatePGFname: e.target.value })}
            />
            <TextField
              margin="dense"
              label="CreatedBy"
              fullWidth
              variant="outlined"
              value={newState.createdBy}
              onChange={(e) => setNewState({ ...newState, createdBy: e.target.value })}
            />
            <DatePicker
              className="form-control-lg"
              selected={
                newState.registeredDate
                  ? new Date(newState.registeredDate.split('-').reverse().join('-'))
                  : null
              }
              onChange={handleDateChange}
              dateFormat="dd-MM-yyyy"
              customInput={
                <TextField
                  margin="dense"
                  label="Registered Date"
                  fullWidth
                  variant="outlined"
                  value={newState.registeredDate}
                  InputProps={{
                    style: { fontSize: '16px', height: '49px', width: '542px' }, // Adjust size here
                  }}
                  InputLabelProps={{
                    style: { fontSize: '14px' }, // Adjust label size here
                  }}
                />
              }
            />

          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseAdd} color="primary">Cancel</Button>
            <Button onClick={() => handleSaveAdd(newState)} color="primary">Add</Button>
          </DialogActions>
        </Dialog>




        {/* Delete Confirmation Dialog */}
        <Dialog open={openDelete} onClose={handleCloseDelete}>
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <Typography>
              Are you sure you want to delete the producton of this Farmer ({selectedRow?.farmerName})?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDelete} color="primary">Cancel</Button>
            <Button onClick={handleDeleteRow} color="primary">Delete</Button>
          </DialogActions>
        </Dialog>



        {/* edit the dialog */}
        <Dialog open={openEdit} onClose={handleCloseEdit}>
          <DialogTitle>Edit Farmer</DialogTitle>
          <DialogContent>
            {selectedRow && (
              <>
                <TextField
                  autoFocus
                  margin="dense"
                  label="farmer Name "
                  fullWidth
                  variant="outlined"
                  value={selectedRow.farmerName}
                  onChange={(e) =>
                    setSelectedRow({ ...selectedRow, farmerName: e.target.value })
                  }
                />
                <TextField
                  margin="dense"
                  label="age"
                  fullWidth
                  variant="outlined"
                  value={selectedRow.age}
                  onChange={(e) =>
                    setSelectedRow({ ...selectedRow, age: Number(e.target.value) })
                  }
                />
                <TextField
                  margin="dense"
                  label="genderId"
                  fullWidth
                  variant="outlined"
                  value={selectedRow.genderId}
                  onChange={(e) =>
                    setSelectedRow({ ...selectedRow, genderId: Number(e.target.value) })
                  }
                />
                <TextField
                  margin="dense"
                  label="casteId"
                  fullWidth
                  variant="outlined"
                  value={selectedRow.casteId}
                  onChange={(e) =>
                    setSelectedRow({ ...selectedRow, casteId: Number(e.target.value) })
                  }
                />
                <TextField
                  margin="dense"
                  label="villageId"
                  fullWidth
                  variant="outlined"
                  value={selectedRow.villageId}
                  onChange={(e) =>
                    setSelectedRow({ ...selectedRow, villageId: Number(e.target.value) })
                  }
                />

                <TextField
                  margin="dense"
                  label="pgid"
                  fullWidth
                  variant="outlined"
                  value={selectedRow.pgId}
                  onChange={(e) =>
                    setSelectedRow({ ...selectedRow, pgid: Number(e.target.value) })
                  }
                />


              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseEdit} color="primary">Cancel</Button>
            <Button onClick={handleSaveEdit} color="primary">Save</Button>
          </DialogActions>
        </Dialog>


        <Dialog open={openEditDialog} onClose={() => setOpenEditDialog(false)} fullWidth maxWidth="sm">
          <DialogTitle>Edit Crop Details</DialogTitle>
          <DialogContent>
            <form>
              <TextField
                fullWidth
                margin="normal"
                label="Seed Sowing Date"
                type="date"
                value={selectedRow?.seedSowingDate || ""}
                onChange={(e) => setSelectedRow({ ...selectedRow, seedSowingDate: e.target.value })}
                InputLabelProps={{ shrink: true }}
              />
              {/* <TextField
        fullWidth
        margin="normal"
        label="Crop Plan ID"
        value={selectedRow?.cropPlanId || ""}
        onChange={(e) => setSelectedRow({ ...selectedRow, cropPlanId: e.target.value })}
      /> */}
              <FormControl fullWidth margin="normal">
                <InputLabel>Seed Class</InputLabel>
                <Select
                  value={selectedRow?.SeedClassId || ""}
                  onChange={(e) =>
                    setSelectedRow({ ...selectedRow, SeedClassId: e.target.value })
                  }
                  label="Seed Class"
                >
                  {seedClasses.map((seedClass) => (
                    <MenuItem key={seedClass.seedClassId} value={seedClass.seedClassId}>
                      {seedClass.className}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                fullWidth
                margin="normal"
                label="Crop Cutting Date"
                type="date"
                value={selectedRow?.cropCuttingDate || ""}
                onChange={(e) => setSelectedRow({ ...selectedRow, cropCuttingDate: e.target.value })}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                fullWidth
                margin="normal"
                label="Cultivated Area (Hectares)"
                value={selectedRow?.cultivatedArea || ""}
                onChange={(e) => setSelectedRow({ ...selectedRow, cultivatedArea: e.target.value })}
              />
              <TextField
                fullWidth
                margin="normal"
                label="Yield (5x5)"
                value={selectedRow?.yield5x5 || ""}
                onChange={(e) => setSelectedRow({ ...selectedRow, yield5x5: e.target.value })}
              />
              <TextField
                fullWidth
                margin="normal"
                label="Production Amount (Kg)"
                value={selectedRow?.productionAmount || ""}
                onChange={(e) => setSelectedRow({ ...selectedRow, productionAmount: e.target.value })}
              />
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenEditDialog(false)} color="secondary">
              Cancel
            </Button>
            <Button onClick={() => handleSaveEdit()} color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </Box>
  );
};

export default Croproduction;